import { RouteStep } from '../types';

const getAccessibleSteps = (steps: RouteStep[], data?: any) =>
  steps.filter((step) => step.isAccessible(data));

export default getAccessibleSteps;
